import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

export const getSuppliers = async () => {
  const res = await axiosInstance.get('supplier/get-suppliers');
  return res.data;
};

export const getSupplierById = async (id) => {
  const res = await axiosInstance.get(`supplier/get-suppliers/${id}`);
  return res.data;
};

export const addSupplier = async (supplier) => {
  const res = await axiosInstance.post('supplier/add-supplier', supplier);
  return res.data;
};

export const updateSupplier = async (id, supplier) => {
  const res = await axiosInstance.put(`supplier/update-supplier/${id}`, supplier);
  return res.data;
};

export const deleteSupplier = async (id) => {
  const res = await axiosInstance.delete(`supplier/delete-supplier/${id}`);
  return res.data;
};
export const searchSuppliers = async (query) => {
  const res = await axiosInstance.get(`supplier/search-supplier`, { params: { q: query } });
  return res.data;
};